require("./o-header.scss");
require("./logo-print.png");

var $ = require("jquery"),

    $header = $('.o-header'),
    $headerFill = $('.o-header__fill'),
    $nav = $('.o-header__main-nav'),
    $openNav = $('.o-header__mobile-btn'),
    openNavActive = "o-header__mobile-btn--active",
    navClassOpen = "o-header__main-nav--open",
    headerClassFixed = "o-header--fixed",
    navOpened = false;

// Open menu on burger click
$openNav.each(function () {
    var $button = $(this);
    $button.on('click', function (e) {
        e.preventDefault();
        var $headerHeight = $header.outerHeight();
        $nav.css({ "height": "calc(100% - " + $headerHeight + "px)", "top": "" + $headerHeight + "px" });
        $headerFill.css("height", "" + $headerHeight + "px");
        if (!navOpened) {
            $button.addClass(openNavActive);
            $nav.addClass(navClassOpen);
            $button.attr('aria-expanded', 'true');
            $nav.prop('hidden', false);
            $header.addClass(headerClassFixed);
            navOpened = true;
            $(document).on("keyup", fnHideMobileNavOnEsc);
        } else {
            $button.removeClass(openNavActive);
            $nav.removeClass(navClassOpen);
            $button.attr('aria-expanded', 'false');
            $nav.prop('hidden', true);
            $header.removeClass(headerClassFixed);
            navOpened = false;
            $(document).off("keyup", fnHideMobileNavOnEsc);
        }
    });
})

// Close menu when click in background or esc key
$(document).on('click', function (e) {
    if (!$nav.is(e.target)
        && !$openNav.is(e.target)
        && $header.has(e.target).length === 0) {
        fnHideMobileNav();
    }
});

function fnHideMobileNavOnEsc(e) {
    if (e.keyCode === 27) {
        fnHideMobileNav();
    }
}

function fnHideMobileNav() {
    $nav.css({ "height": "auto", "top": "auto" });
    $headerFill.css("height", "auto");
    if ($openNav.css('display') == 'none') {
        $nav.prop('hidden', false);
    }

    $openNav.removeClass(openNavActive);
    $nav.removeClass(navClassOpen);
    $openNav.attr('aria-expanded', 'false');
    $nav.prop('hidden', true);
    $header.removeClass(headerClassFixed);
    navOpened = false;
    $(document).off("keyup", fnHideMobileNavOnEsc);

}

if ($openNav.css('display') == 'none') {
    $nav.prop('hidden', false);
}

// Close menu when viewport reaches 'sm' breakpoint (768px)
function closeMenu(x) {
    if (x.matches) { // If media query matches
        fnHideMobileNav();
    }
}

var x = window.matchMedia("(min-width: 768px)")
closeMenu(x) // Call listener function at run time
x.addListener(closeMenu) // Attach listener


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/organism/o-header/o-header.chunk.js